import { StrictMode } from 'react'
import { createRoot, hydrateRoot } from 'react-dom/client'
import './index.css'
import App from './App'

const root = document.getElementById('root')!
const app = <StrictMode><App pathname={window.location.pathname} /></StrictMode>

// In development the root contains the prerender placeholder comment, but no HTML to hydrate.
if (root.children.length > 0) {
  hydrateRoot(root, app)
} else {
  createRoot(root).render(app)
}
